import { css } from "lit";
export const styles = css `
	:host {
		box-sizing: border-box !important;
	}

	:host *,
	:host *::before,
	:host *::after {
		box-sizing: inherit !important;
	}
`;
//# sourceMappingURL=host-styles.js.map